<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-input-docs-preview></ui-input-docs-preview></p>
<h1 id="description">Description</h1>
<p>A input box with a optional label that can handle normal method, NgModel, FormControl and  </p>
<p>a control inside a FormGroup. Current support is a normal text and a password field.</p>
<h1 id="usage">Usage</h1>
<p>There are multiple ways to use this component like shown below</p>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">form</span> [<span class="hljs-attr">formGroup</span>]=<span class="hljs-string">"testForm"</span>  
      <span class="hljs-attr">class</span>=<span class="hljs-string">"thisForm"</span>&gt;</span>  
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-input</span> <span class="hljs-attr">id</span>=<span class="hljs-string">"inputOne"</span>  
              <span class="hljs-attr">value</span>=<span class="hljs-string">"inputOne"</span>  
              <span class="hljs-attr">label</span>=<span class="hljs-string">"inputOne with label"</span>  
              (<span class="hljs-attr">submit</span>)=<span class="hljs-string">"onSubmit($event)"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-input</span>&gt;</span>  

    <span class="hljs-tag">&lt;<span class="hljs-name">ui-input</span> <span class="hljs-attr">id</span>=<span class="hljs-string">"inputTwo"</span>  
              <span class="hljs-attr">formControlName</span>=<span class="hljs-string">"testInput2"</span>  
              <span class="hljs-attr">label</span>=<span class="hljs-string">"inputTwo with validation"</span>  
              [<span class="hljs-attr">validation</span>]=<span class="hljs-string">"testForm.controls.testInput2"</span>  
              (<span class="hljs-attr">submit</span>)=<span class="hljs-string">"onSubmit($event)"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-input</span>&gt;</span>  

    <span class="hljs-tag">&lt;<span class="hljs-name">ui-input</span> <span class="hljs-attr">id</span>=<span class="hljs-string">"inputThree"</span>  
              [(<span class="hljs-attr">ngModel</span>)]=<span class="hljs-string">"inputThree"</span>  
              [<span class="hljs-attr">ngModelOptions</span>]=<span class="hljs-string">"{{ '{' }}standalone: true{{ '}' }}"</span>  
              <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"Write something"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-input</span>&gt;</span>  

    <span class="hljs-tag">&lt;<span class="hljs-name">ui-input</span> <span class="hljs-attr">id</span>=<span class="hljs-string">"inputFour"</span>  
              <span class="hljs-attr">label</span>=<span class="hljs-string">"Disabled input"</span>  
              <span class="hljs-attr">value</span>=<span class="hljs-string">"myemail&#64;bannerflow.com"</span>
              <span class="hljs-attr">disabled</span>=<span class="hljs-string">"true"</span>  
              <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"You cant write"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-input</span>&gt;</span>  
<span class="hljs-tag">&lt;/<span class="hljs-name">form</span>&gt;</span>  

<span class="hljs-tag">&lt;<span class="hljs-name">ui-input</span> <span class="hljs-attr">id</span>=<span class="hljs-string">"inputFive"</span>  
          <span class="hljs-attr">label</span>=<span class="hljs-string">"Simple formControl"</span>  
          [<span class="hljs-attr">formControl</span>]=<span class="hljs-string">"simpleController"</span>  
          [<span class="hljs-attr">validation</span>]=<span class="hljs-string">"simpleController"</span>  
          <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"You cant write"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-input</span>&gt;</span>  

<span class="hljs-tag">&lt;<span class="hljs-name">ui-input</span> <span class="hljs-attr">id</span>=<span class="hljs-string">"inputOne"</span>
          <span class="hljs-attr">label</span>=<span class="hljs-string">"Expandable input"</span>
          <span class="hljs-attr">iconPosition</span>=<span class="hljs-string">"left"</span>
          <span class="hljs-attr">icon</span>=<span class="hljs-string">"search"</span>
          <span class="hljs-attr">expand</span>=<span class="hljs-string">"true"</span>
          (<span class="hljs-attr">submit</span>)=<span class="hljs-string">"onSubmit($event)"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-input</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ui-input</span> <span class="hljs-attr">id</span>=<span class="hljs-string">"inputOne"</span>
          <span class="hljs-attr">label</span>=<span class="hljs-string">"Dynamic input"</span>
          <span class="hljs-attr">dynamicWidth</span>=<span class="hljs-string">"true"</span>
          (<span class="hljs-attr">submit</span>)=<span class="hljs-string">"onSubmit($event)"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-input</span>&gt;</span></code></pre>
<p>If you are using <code>[formControl]</code> then you must import the module <code>ReactiveFormsModule</code> to prevent errors regarding that.  </p>
<p>You can also implement FormGroup to have multiple controllers inside your form.  </p>
<p>Or if you want, you can use only independed controller like <code>SimpleController</code>  </p>
<pre><code class="language-javascript">changedText: <span class="hljs-built_in">Object</span> = {{ '{' }}{{ '}' }};
myForm: FormGroup;

simpleController: FormControl;

<span class="hljs-keyword">constructor</span>(private fb: FormBuilder){{ '{' }}

    <span class="hljs-keyword">this</span>.simpleController = <span class="hljs-keyword">new</span> FormControl(<span class="hljs-string">''</span>, [Validators.required]);

    <span class="hljs-keyword">this</span>.myForm = <span class="hljs-keyword">this</span>.fb.group({{ '{' }}
        <span class="hljs-attr">input1</span>: [<span class="hljs-string">''</span>, [Validators.required]]
    {{ '}' }})

    <span class="hljs-comment">// Listen to whole testForm</span>
    <span class="hljs-keyword">this</span>.myForm.valueChanges.subscribe(<span class="hljs-function">(<span class="hljs-params">arg: any</span>) =&gt;</span> {{ '{' }}
            <span class="hljs-keyword">this</span>.changeText = {{ '{' }}
                <span class="hljs-attr">text1</span>: arg.input1
            {{ '}' }};
        {{ '}' }});

    <span class="hljs-comment">// Only listen to testInput1</span>
    <span class="hljs-keyword">this</span>.myForm.get(<span class="hljs-string">'input1'</span>)!.valueChanges.subscribe(<span class="hljs-function"><span class="hljs-params">val</span> =&gt;</span> {{ '{' }}
        <span class="hljs-keyword">this</span>.changeText = {{ '{' }}<span class="hljs-attr">text1</span>: val{{ '}' }};
    {{ '}' }});
{{ '}' }}</code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">public</td>
<td align="left">ID.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Placeholder text.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Label</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Tabindex</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Autocomplete when user is typing. Default is &#39;on&#39; but can be also &#39;off&#39;</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Autofocus automatically sets focus to the input when the input component is initialized</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Input type, allowed are &#39;text&#39; and &#39;password&#39;</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Max value length of the input.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Min value length of the input.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Validation</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">No borders when not focusing</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">No borders at all</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Disable undo.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Position of the icon, can be left or right</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Icon</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">SvgIcon</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Should the field be minimized from start?</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Should the field dynamically match input string width?</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Characters that should be allowed, allows RegExp as a string.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Select all text when input gets focus</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Blur text field on submit</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">public</td>
<td align="left">Submit event.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Cancel event.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Blur event.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Undo event.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Redo event.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Change event.</td>
</tr>
</tbody></table>
